<div class="w-full">
    <div class="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full space-y-6">
            <!-- Título del diálogo -->
            <div class="px-6 pt-6 pb-3 border-b border-gray-200 dark:border-gray-700">
                <h2 class="text-2xl font-bold text-gray-800 dark:text-white">Detalle de la tarea</h2>
            </div>

            <!-- Contenido -->
            <div class="px-6 py-4 space-y-6">

                <!-- Campo: Título -->
                <div class="mb-4">
                    <label for="tipoAsignacion"
                        class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">
                        Titulo
                    </label>
                    <input id="titulo" type="text" formControlName="titulo"
                        class="w-full px-4 py-2 border border-blue-400 dark:border-blue-300 rounded-md bg-white dark:bg-slate-700 text-gray-900 dark:text-white text-lg font-bold leading-snug focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Escribe el título aquí" />
                </div>

                <!-- Tipo de asignación -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                    <!-- Tipo -->
                    <div>
                        <label for="tipoAsignacion"
                            class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">
                            Tipo de asignación
                        </label>
                        <select id="tipoAsignacion" formControlName="tipoAsignacion"
                            class="w-full px-4 py-2 rounded-md border border-blue-400 dark:border-blue-300 bg-white dark:bg-slate-700 text-gray-900 dark:text-white">
                            <option [value]="tipoAsignacion.TODOS">Todos los usuarios</option>
                            <option [value]="tipoAsignacion.SEDE">Usuarios de sede específica</option>
                            <option [value]="tipoAsignacion.COORDINACION">Usuarios de supervisor específico</option>
                            <option [value]="tipoAsignacion.PERSONAL">Usuario específico</option>
                        </select>
                    </div>

                    <!-- Sede -->
                    <div *ngIf="form.get('tipoAsignacion')?.value === tipoAsignacion.SEDE">
                        <label for="tipoAsignacion"
                            class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">
                            Sede
                        </label>
                        <select id="sedeId" formControlName="sedeId"
                            class="w-full px-4 py-2 rounded-md border border-blue-400 dark:border-blue-300 bg-white dark:bg-slate-700 text-gray-900 dark:text-white">
                            <option [ngValue]="null" disabled>Seleccione sede</option>
                            <option *ngFor="let sede of sedes" [ngValue]="sede.id">{{ sede.nombre }}</option>
                        </select>
                    </div>

                    <!-- Coordinador -->
                    <div *ngIf="form.get('tipoAsignacion')?.value === tipoAsignacion.COORDINACION">
                        <label for="tipoAsignacion"
                            class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">
                            Supervisor
                        </label>

                        <ng-select class="custom-ng-select" [items]="coordinadores" bindLabel="nombreCoordinador"
                            bindValue="codi_usuario" formControlName="coordinadorId" [clearable]="false"
                            [searchable]="true" [dropdownPosition]="'auto'">
                        </ng-select>
                    </div>

                    <!-- Usuarios específicos -->
                    <div class="form-group col-md-12"
                        *ngIf="form.get('tipoAsignacion')?.value === tipoAsignacion.PERSONAL">
                        <label for="tipoAsignacion"
                            class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">
                            Usuarios
                        </label>

                        <ng-select class="custom-ng-select-usuarios w-100" [items]="usuarios" bindLabel="nombreCompleto"
                            bindValue="codi_usuario" formControlName="usuarioId" [multiple]="true" [searchable]="true"
                            [clearable]="false">
                        </ng-select>
                    </div>
                </div>
                <!-- Editor enriquecido -->
                <!-- Editor enriquecido (sin envolver en divs innecesarios) -->
                <div class="md:col-span-2">
                    <label for="tipoAsignacion"
                        class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">
                        Descripción de la Tarea
                    </label>

                    <quill-editor formControlName="descripcionAsignacion" [modules]="editorModules"
                        style="min-height: 300px; width: 100%;"
                        class="block w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-slate-700 text-gray-900 dark:text-white">
                    </quill-editor>
                </div>
            </div>

            <!-- Acciones -->
            <div class="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700 px-6 pb-4">
                <button type="button"
                    class="min-w-[120px] px-5 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-md shadow-sm transition"
                    (click)="onClose()">
                    Cancelar
                </button>
                <button type="submit"
                    class="min-w-[120px] px-5 py-2 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-md shadow-sm transition">
                    Guardar
                </button>
            </div>
        </form>
    </div>
</div>